


































import Component from 'vue-class-component';
import { IDictionary } from '@/entities/dictionary.interface';
import { IFormControl } from '@/entities/form.interface';
import { EditPage } from '@/components/base/edit/edit-page';
import { IListItem } from '../../../entities/list-item.interface';
import sitesApi from '@/api/sites.api';

import chatLogsApi from '@/api/chat-logs.api';

import { ISite } from '@/entities/sites/site.interface';

@Component({})
export default class ChatLogsSubmit extends EditPage {
    public parentPath: string = '/app/chat-logs';

    public sites: IListItem[] = [];

    public formState: IDictionary<IFormControl> = {
        clientUsername: {
            key: 'clientUsername',
            label: 'Client Name',
            value: '',
            validators: 'required'
        },
        siteId: {
            key: 'siteId',
            label: `Site`,
            value: '',
            validators: 'required'
        },
        conversation: {
            key: 'conversation',
            label: `Conversation`,
            value: '',
            validators: 'required'
        }
    };

    public async created() {
        await super.created();
        sitesApi.list().then((items: ISite[]) => {
            const mapped = items.map((x) => {
                return {value: x.id, heading: x.sitename};
            });
            this.sites = [{heading: 'Please select site', value: ''}, ...mapped];
        });
    }

    public create(body: any): Promise<number> {
        return chatLogsApi.submit(body);
    }

    protected update(id: number): Promise<any> {
        throw new Error('not supported');
    }

    protected detail(body: any): Promise<any> {
        throw new Error('not supported');
    }
}
